import { Add, KeyboardBackspace } from "@mui/icons-material";
import {
  Button,
  Container,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetFilesFromFolderQuery } from "src/api/services/bucketApi";
import { useIsMobile } from "src/hooks/useIsMobile";
import CarouselSkeleton from "src/shared/components/CarouselSkeleton";
import FileView from "../FileView";
import UpdateInsuranceModal from "./components/UpdateInsuranceModal";
import { useCallback, useState } from "react";

const InsuranceDetails = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { data: files = [], isFetching } =
    useGetFilesFromFolderQuery("insurance");
  const { t } = useTranslation();
  const page = "account.insurance-details";
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Container maxWidth="xl" disableGutters>
        <Stack gap={isMobile ? 2 : 4}>
          <Stack direction={"row"} alignItems={"center"}>
            {isMobile ? (
              <IconButton
                sx={{ color: "#00B6B8" }}
                onClick={() => navigate(-1)}
              >
                <KeyboardBackspace fontSize="large" />
              </IconButton>
            ) : null}

            <Stack direction="row" gap={2}>
              <Typography variant="h5" fontWeight={700}>
                {t(`${page}.header`, "Insurance Details")}
              </Typography>
              <Button onClick={handleOpen} startIcon={<Add />} variant="text">
                {t("payment-methods.add")}
              </Button>
            </Stack>
          </Stack>
          {isFetching ? (
            <CarouselSkeleton />
          ) : (
            <Stack
              display={files.length > 0 ? "inherit" : "none"}
              role="list"
              maxHeight="700px"
              width="100%"
              gap="16px"
              overflow="auto"
              padding="5px"
            >
              {files.map((file) => (
                <FileView key={file.name} file={file} />
              ))}
            </Stack>
          )}
        </Stack>
      </Container>
      <UpdateInsuranceModal open={open} onClose={handleClose} />
    </>
  );
};

export default InsuranceDetails;
